import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { SeoMeta } from '../../../../components/SeoMeta'
import { MagnoliaPage } from '../../MagnoliaApp'

import { LoginPageView } from './LoginPageView'

// “login” is a noun (an event or credentials), “log in” is a verb.
// “logout” is a noun (an event), “log out” is a verb.

interface IProps
  extends Readonly<{
    errors: ReadonlyArray<Error>
    loading: boolean
  }> {}

export const LoginPage: MagnoliaPage<IProps> = () => {
  const {
    magnolia: {
      account: { login: strings },
    },
  } = useTranslation()

  return (
    <>
      <SeoMeta title={strings.pageTitle} />
      <LoginPageView />
    </>
  )
}
